import {
  faCircleCheck,
  faCircleMinus,
  faCirclePlus,
  faClock,
} from '@fortawesome/free-solid-svg-icons';

import {
  CONFIRMED,
  CONFIRMED_LABEL,
  NOVISIT,
  NOVISIT_LABEL,
  VISITED,
  VISITED_LABEL,
  WAITING,
  WAITING_LABEL,
} from '@app/constants/clientStatuses';
import type { TClientStatuses } from '@app/types/Records';

export const ClientStatues: TClientStatuses[] = [
  {
    status: WAITING,
    label: WAITING_LABEL,
    color: '#ADD8E6',
    icon: faClock,
  },
  {
    status: CONFIRMED,
    label: CONFIRMED_LABEL,
    color: '#F0AD4E',
    icon: faCirclePlus,
  },
  {
    status: NOVISIT,
    label: NOVISIT_LABEL,
    color: '#E14F4F',
    icon: faCircleMinus,
  },
  {
    status: VISITED,
    label: VISITED_LABEL,
    color: '#2DA540',
    icon: faCircleCheck,
  },
];

export const RecordStatusColor = {
  waiting: '#ADD8E6',
  confirmed: '#FFDAA6',
  novisit: '#F0A7A7',
  visited: '#96D29E',
};
